import { styled } from 'styled-components';
import { APP_BAR_NOTIFICATION_OFFSET, MOBILE_STICKY_OFFSET } from '../../../constants.js';
import { Media } from '../../../theme/Media.js';
import Typography from '../../Typography/index.js';
import { PAGE_HEADER_MIN_HEIGHT, PAGE_HEADER_Z_INDEX } from './constants.js';
export const Wrapper = styled.div `
  position: sticky;
  top: ${APP_BAR_NOTIFICATION_OFFSET};
  z-index: ${PAGE_HEADER_Z_INDEX};
  margin-bottom: 24px;

  @media ${Media.mdMax} {
    top: calc(${MOBILE_STICKY_OFFSET}px + ${APP_BAR_NOTIFICATION_OFFSET});
  }

  @media ${Media.xsMax} {
    margin-bottom: 8px;
  }
`;
export const InnerWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  background-color: ${({ theme }) => theme.colors.grey00_1};
  padding: 24px;
  min-height: ${PAGE_HEADER_MIN_HEIGHT.desktop}px;
  box-shadow: inset 0 -1px 0 0 ${({ theme }) => theme.colors.grey10_1};

  & ${Typography.Headline} {
    align-self: flex-start;
    margin: 0;
  }

  @media ${Media.xsMax} {
    min-height: ${PAGE_HEADER_MIN_HEIGHT.mobile}px;
    padding: 12px;
    flex-wrap: wrap;
    gap: 12px;
  }
`;
export const ActionsWrapper = styled.div `
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 12px;
  min-height: 34px;

  @media ${Media.xsMax} {
    width: 100%;
    justify-content: flex-end;
  }
`;
export const TabsWrapper = styled.div `
  background-color: ${({ theme }) => theme.colors.grey00_1};
  box-shadow: inset 0 -1px 0 0 ${({ theme }) => theme.colors.grey10_1};
  overflow-x: auto;

  @media ${Media.smMin} {
    padding: 0 16px;
  }
`;
export const SubTitleWrapper = styled.div `
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  min-height: 28px;
  flex-wrap: wrap;
`;
export const TitleWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
  word-break: break-word;
  color: ${({ theme }) => theme.colors.black_1};
`;
export const CollapsibleWrapper = styled.div `
  /* Negative z-index keeps the area behind the opaque title and tabs rows while it slides away. */
  position: relative;
  z-index: -1;
  background-color: ${({ theme }) => theme.colors.grey00_1};
  box-shadow: inset 0 -1px 0 0 ${({ theme }) => theme.colors.grey10_1};
  padding: 16px 24px;
  transform: translateY(${({ $isHidden }) => ($isHidden ? '-100%' : '0')});
  transition: transform 0.2s ease-in-out;

  @media ${Media.xsMax} {
    padding: 12px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
